import { useRowSelect, SelectTypes } from '@table-library/react-table-library/select'
import type { SelectOptions } from '@table-library/react-table-library/types/select'

export const useTableSelect = (
	data: any,
	onSelectChange: (action: any, state: any) => void,
	options: SelectOptions = {}
) => {
	const select = useRowSelect(
		data,
		{
			onChange: onSelectChange
		},
		{
			isCarryForward: false,
			rowSelect: SelectTypes.MultiSelect,
			...options
		}
	)

	return { select }
}
